import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Typography, Link, Accordion, AccordionSummary, AccordionDetails, Stepper, Step, StepLabel, StepContent, StepConnector } from "@mui/material";
import { SimpleTreeView as TreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Button from "../../Button";
import { useCourse } from "../../../pages/course/hooks";
import { useStudy } from "../../../pages/study/hooks";
import { styled } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import menuSvg from "../../../assets/svgs/menu.svg";
import { chapterPassed } from "../../../pages/study/course/gateUtils";


const useStyles = makeStyles()((theme) => ({
    treeItem: {
        backgroundColor: 'rgba(var(--mui-palette-primary-mainChannel) / var(--mui-palette-action-selectedOpacity))'
    }
}));
const CustomStepIcon = styled('div')(({ theme, active, completed }) => ({
    background: active
        ? 'linear-gradient(256.72deg, #FFB41D 8.05%, #FA9315 38.95%, #F25807 87.28%)' // Active (orange)
        : completed
            ? 'linear-gradient(256.72deg, #FFB41D 8.05%, #FA9315 38.95%, #F25807 87.28%)'
            : '#F0F0F1',
    width: 12,
    height: 12,
    borderRadius: '50%',
    border: '0.5px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
}));

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    '& .MuiStepConnector-line': {
        borderColor: '#F0F0F1',
        borderWidth: 2,
        margin: 0,
        minHeight: '100%',
        position: 'absolute',
        top: 0,
        left: '1em',
    },
}));
const OrangeConnector = styled('div')({
    width: '2px',
    backgroundColor: '#FF6900', // Orange color
    height: '50%', // Adjust this value for desired spacing
    position: 'absolute',
    left: '1em',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 0,
});


const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
    display: 'flex',
    position: 'relative',
    paddingLeft: '20px',
}));

const PlusIcon = <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="4" width="11" height="3" rx="1" fill="#000001" /><rect x="7" width="11" height="3" rx="1" transform="rotate(90 7 0)" fill="#000001" /></svg>

const MinusIcon = <svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="11" height="3" rx="1" fill="#000001" /></svg>


export default function Outline({ courseId, lessonPlan, gate }) {
    const { classes } = useStyles();
    const { current } = useCourse();
    const { progress } = useStudy();
    const [expandedItems, setExpandedItems] = React.useState([courseId]);
    const itemIds = React.useRef([]);
    const [expandedSection, setExpandedSection] = React.useState(null);

    const handleExpandedItemsChange = (event, ids) => {
        setExpandedItems(ids);
    };

    const handleExpandClick = () => {
        setExpandedItems((oldExpanded) =>
            oldExpanded.length === 0
                ? itemIds.current
                : [],
        );
    };

    const appendItemIds = (id) => {
        itemIds.current = [...new Set([...itemIds.current, String(id)])];
    };

    const renderChapter = (chapter) => {
        if (chapter && Object.keys(chapter).length > 0) {
            appendItemIds(chapter.chapterId);

            return <TreeItem
                key={chapter.chapterId}
                itemId={chapter.chapterId}
                className={progress['chapter'] && progress['chapter'] == chapter.chapterId ? classes.treeItem : ''}
                label={
                    <div>
                        <Typography variant="body1">{chapter.name}</Typography>
                        <Link href={chapter.contentURL} target="_blank" rel="noopener">
                            View Content
                        </Link>
                    </div>
                }
            >
                {chapter.assessments.map((assessment) => {
                    appendItemIds(assessment.id);
                    return <TreeItem
                        key={assessment.id}
                        itemId={assessment.id}
                        label={`Assessment (${assessment.type})`}
                    />
                })}
            </TreeItem>
        }
    };

    const renderSection = (section, ind) => {
        if (section && Object.keys(section).length) {
            appendItemIds(ind);
            return (<TreeItem
                key={section.sectionId}
                itemId={section.sectionId}
                label={section.name}
                className={progress['section'] && progress['section'] == section.sectionId ? classes.treeItem : ''}
            >
                {section?.chapters?.map(renderChapter)}
            </TreeItem>)
        }
    }

    React.useEffect(() => {
        let items = [courseId];
        if (progress['section']) items.push(progress['section']);
        if (progress['chapter']) items.push(progress['chapter']);
        setExpandedItems(items);
    }, [progress]);


    const handleAccordionChange = (sectionId) => (event, isExpanded) => {
        setExpandedSection(isExpanded ? sectionId : null);
    };

    React.useEffect(() => {
        if (progress?.section) {
            setExpandedSection(progress.section);
        }
    }, [progress.section]);

    return (
        // <Box>
        //     <div>
        //         <Button onClick={handleExpandClick} placeholder={expandedItems.length === 0 ? 'Expand all' : 'Collapse all'} />
        //     </div>
        //     <TreeView
        //         expandedItems={expandedItems}
        //         onExpandedItemsChange={handleExpandedItemsChange}
        //     >
        //         <TreeItem itemId={current.id} label={current?.courseName}>
        //             {lessonPlan?.sections?.map(renderSection)}
        //         </TreeItem>
        //     </TreeView>
        // </Box>
        <Box>
            <Box
                sx={{
                    background: '#29ABE233',
                    borderRadius: 1,
                    padding: 1,
                    border: '1px solid #29ABE2',
                    fontWeight: '600',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                {current?.courseName} <img width={'15px'} src={menuSvg} alt="menu" />
            </Box>
            <Box sx={{
                height: 'calc(100vh - 220px)',
                overflowY: 'scroll',
                '&::-webkit-scrollbar': {
                    width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#E1E4E6',
                    borderRadius: '10px',
                },
                '&:hover, &:focus-within': {
                    '&::-webkit-scrollbar-thumb': {
                        background: 'linear-gradient(193.28deg, #29ABE2 5.42%, #2DA2E2 12.18%, #398CE2 33.81%, #417EE2 54.77%, #447AE2 73.02%)',
                        width: '12px',
                        cursor: 'pointer',
                    },
                },
            }}>
                {lessonPlan?.sections?.map((section, index) => {
                    return (
                        <Accordion
                            key={section?.sectionId}
                            expanded={expandedSection === section?.sectionId}
                            onChange={handleAccordionChange(section?.sectionId)}
                            sx={{
                                mx: 1,
                                my: 1,
                                boxShadow: 'none',
                                borderRadius: '15px',
                                border: '1px solid #24272C1A',
                                '&::before': {
                                    display: 'none', // Hide the ::before element
                                },
                                '&.Mui-expanded': {
                                    mx: 1
                                }
                            }}>
                            <AccordionSummary
                                key={section?.sectionId}
                                expandIcon={
                                    expandedSection === section?.sectionId ? (
                                        MinusIcon
                                    ) : (
                                        PlusIcon
                                    )
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    background: expandedSection === section?.sectionId ? '#CFEBFE40' : '',
                                    borderRadius: '15px',
                                    '&.Mui-expanded': {
                                        borderBottom: '1px solid #24272C1A',
                                        borderBottomLeftRadius: '0px',
                                        borderBottomRightRadius: '0px'
                                    },

                                    fontWeight: '700',
                                    fontSize: '0.8em'
                                }}
                            >

                                {section?.name}
                            </AccordionSummary>
                            <AccordionDetailsStyled sx={{
                                padding: '10px 10px',
                            }}>
                                <Stepper
                                    orientation="vertical"
                                    connector={<CustomStepConnector />}
                                >
                                    {section?.chapters?.map((chapter, index) => {
                                        const isChapterActive = progress?.chapter === chapter?.chapterId;
                                        const allPairs = lessonPlan.sections.flatMap(sec =>
                                            (sec.chapters || []).map(ch => ({ sectionId: sec.sectionId, chapterId: ch.chapterId })));
                                        const currentChapterIndex = allPairs.findIndex(p => p.chapterId === chapter.chapterId);

                                        // Session gate: a chapter shows completed only when all its
                                        // sessions PASSED; everything past the first non-passed
                                        // chapter is locked (linear lock). Fall back to the old
                                        // position heuristic while the gate loads.
                                        let isChapterCompleted, isChapterLocked = false;
                                        if (gate) {
                                            isChapterCompleted = chapterPassed(gate, section.sectionId, chapter.chapterId);
                                            const firstOpenIndex = allPairs.findIndex(p => !chapterPassed(gate, p.sectionId, p.chapterId));
                                            isChapterLocked = firstOpenIndex !== -1 && currentChapterIndex > firstOpenIndex;
                                        } else {
                                            const activeChapterIndex = allPairs.findIndex(p => p.chapterId === progress.chapter);
                                            isChapterCompleted = currentChapterIndex < activeChapterIndex;
                                        }

                                        return (
                                            <Step key={chapter?.chapterId} completed={isChapterCompleted}>
                                                {index > 0 && isChapterCompleted && (
                                                    <OrangeConnector />
                                                )}
                                                <StepLabel
                                                    StepIconComponent={(props) => (
                                                        <CustomStepIcon active={isChapterActive} completed={isChapterCompleted} />
                                                    )}
                                                    StepIconProps={{ icon: null }}
                                                >
                                                    <Typography sx={{
                                                        display: 'flex', alignItems: 'center', gap: '4px',
                                                        fontSize: '0.7em', fontWeight: '600',
                                                        color: isChapterActive ? '#FF6900' : isChapterCompleted ? '#729EB1' : isChapterLocked ? '#B0B3B8' : '#000'
                                                    }}>
                                                        {chapter.name}
                                                        {isChapterLocked && <LockIcon sx={{ fontSize: '1.2em', color: '#B0B3B8' }} />}
                                                    </Typography>
                                                </StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </AccordionDetailsStyled>
                        </Accordion>
                    )
                })}
            </Box>
        </Box>
    )
}